import {Component, Input} from '@angular/core';


export interface OutdatedCartMessage {
  outdatedCartMessage: string;
}

@Component({
  selector: 'dcp-outdated-cart-message',
  templateUrl: './outdated-cart-message.component.html',
  styleUrls: ['./outdated-cart-message.component.scss']
})
export class OutdatedCartMessageComponent {

  @Input() message: string;
  @Input() isShown: boolean = true;

  closeMessage() {
    this.isShown = false;
  }
}
